import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import api from "../../../services/api";
import { configuredAlertsKeys } from "../queryKeys";
import { GridQueryParams, IConfiguredAlertsListResponse } from "../@types";
import useListDeliveryMethods from "./useListDeliveryMethods";
import { getDeliveryMethodsLabelList } from "../utils";

const useListConfiguredAlerts = (queryParams?: GridQueryParams) => {
  const { data, isPending } = useQuery<IConfiguredAlertsListResponse>({
    queryKey: configuredAlertsKeys.listWithParams(queryParams),
    queryFn: () =>
      api
        .listSubscriptions(queryParams)
        .then((resp: AxiosResponse<IConfiguredAlertsListResponse>) => resp.data)
  });

  const { deliveryMethodsList } = useListDeliveryMethods();

  const configuredAlertsWithMethodsLabels = useMemo(() => {
    if (!data?.results || !deliveryMethodsList) {
      return [];
    }

    return data?.results?.map(alert => {
      const alertDeliveryItems = deliveryMethodsList.filter(
        method => method.id && alert.actions.includes(method.id)
      );
      return {
        ...alert,
        deliveryLabels: getDeliveryMethodsLabelList(alertDeliveryItems)
      };
    });
  }, [data?.results, deliveryMethodsList]);

  return {
    configuredAlertsList: configuredAlertsWithMethodsLabels,
    totalResultCount: data?.count || 0,
    totalEventsConfigured: data?.total_configured_events || 0,
    isLoadingConfiguredAlertsList: isPending
  };
};

export default useListConfiguredAlerts;
